import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { serverInfo } from "../../../../../App";
import noImage from "../../../../../Assets/Images/no-image.png";
export default function OnlineSmall({ user }) {
  console.log('onlineuser small',user);

  const { imageCdnUrl } = useContext(serverInfo);

  const [userInfo, setUserInfo] = useState([]);

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`api/user_info/${user}`).then((res) => {
        if (res.data.status === 200) {
          setUserInfo(res.data.users);
        }
      });
  }, []);

  return (
    <>
      <div className=" StarON  me-2">
        <img
          src={
            user?.image != null
              ? imageCdnUrl + user?.image
              : noImage
          }
          alt=""
          className="star-online-ac"
        />
        <span className="light-green">🟢</span>
      </div>
    </>
  );
}
